import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class mailService {    
  async fetch(params) {
    try {      
      const result = await client.get('mail/index', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async create(obj) {
    try {
      const result = await client.post('mail/create', obj);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async update(id, obj) {
    try {
      const result = await client.post(`mail/update/${id}`, obj);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async test(id, obj) {
    try {
      const result = await client.post(`mail/test/${id}`, obj);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async get(id) {
    try {
      const result = await client.get(`mail/view/${id}`);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async remove(id) {
    try {
      const result = await client.post(`mail/delete/${id}`);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new mailService();
